import RoleAdvancedForm from './RoleAdvancedForm'

export default RoleAdvancedForm
